export default {
  data() {
    return {
      CORE: window.CORE,
      DOTO: window.CORE,
      window,
    }
  },
}
